import { buildTranslate } from 'locales'

import type { CopyKey } from './copyKeyOf'

const t = buildTranslate('components.ai.picker.canonical')

type PlaceholderArgs = {
  copyKey: CopyKey
  parentCopyKey: CopyKey
  hasNoScope: boolean
  // Level 1 holds picks, though none of them is in the catalog
  hasParentPicks: boolean
  isSpecific: boolean
  isMultiselect: boolean
}

/** What a level's field says before anything is picked: why it is empty, or what it searches */
const placeholderOf = ({
  copyKey,
  parentCopyKey,
  hasNoScope,
  hasParentPicks,
  isSpecific,
  isMultiselect,
}: PlaceholderArgs): string => {
  if (hasNoScope && hasParentPicks) {
    return t(`${parentCopyKey}.select_matched_first`)
  }
  if (hasNoScope) return t(`${parentCopyKey}.select_first`)
  if (isSpecific) return t(`${copyKey}.search_versions`)
  if (isMultiselect) return t(`${copyKey}.select_many`)
  return t(`${copyKey}.select`)
}

export default placeholderOf
